






























// Copyright © 2021 Move Closer

import { defineComponent, SetupContext } from '@vue/composition-api'

import { DashmixBoxTabsProps } from './BoxTabs.contracts'
import { dashmixBoxTabsProps, useDashmixBoxTabs } from './BoxTabs.hooks'

import { DashmixBox } from '../../atoms/Box'
import { DashmixNavTabs } from '../NavTabs'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const DashmixBoxTabs = defineComponent({
  name: 'DashmixBoxTabs',
  components: { DashmixBox, DashmixNavTabs },
  props: dashmixBoxTabsProps,
  emits: ['update:active'],

  setup (props: DashmixBoxTabsProps, ctx: SetupContext) {
    return useDashmixBoxTabs(props, ctx)
  }
})

export default DashmixBoxTabs
